import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import TextInput from 'Components/Form/Input/TextInput'
import { setCarInfo, setDeliberatelyFileContent } from '../../Actions/reducer'
import { useDispatch, useSelector } from 'react-redux'
import { IApplicationState } from 'Store/types'
import React, { useEffect, useState } from 'react'
import VisitsApiPaths from '../../Constants/VisitsApiPaths'
import CurrencyInput from 'Components/Form/Input/CurrencyInput'
import FDMBottomSheetSelectInput from 'Components/Form/Input/FDMBottomSheetSelectInput'
import PlateInput from 'Components/Form/Input/PlateInput'
import moment from 'jalali-moment'
import { IPlateModel } from 'Components/Plate'
import englishFilterOnKeyPress from 'Utils/englishFilterOnKeyPress'
import { instance } from 'Services/instance'
import QueryStringBuilder from 'Utils/QueryStringBuilder.Utilts'
import Icon from 'Components/Icon'
import PodSpaceImage from 'Components/Image/PodSpaceImage'
import { useNetStatus } from 'Contexts/NetStatusContext'

const GetCarInfoPage = (props: { handleNext: () => void; handleBack: () => void }) => {
  const [t] = useTranslation()
  const { carInfo, customerDeliberately, vehicleVisitingPoints, storeFileType, draftVisitId } =
    useSelector((store: IApplicationState) => store.visits.newVisit)
  const {
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm({ mode: 'all' })
  const dispatch = useDispatch()
  const [licensePlateInquiryLoading, setLicensePlateInquiryLoading] = useState<boolean>(false)
  const [ocrLoading, setOcrLoading] = useState<boolean>(false)
  const { netStatus } = useNetStatus()
  const vehicleTypesData = useSelector((store: IApplicationState) => store.visits.vehicleTypes.data)
  const vehicleUsagesData = useSelector(
    (store: IApplicationState) => store.visits.vehicleUsages.data,
  )
  const vehicleBrandsData = useSelector(
    (store: IApplicationState) => store.visits.vehicleBrands.data,
  )
  const vehicleTipsData = useSelector((store: IApplicationState) => store.visits.vehicleTips.data)
  const vehicleColorsData = useSelector(
    (store: IApplicationState) => store.visits.vehicleColors.data,
  )
  const cargoRoomData = useSelector((store: IApplicationState) => store.visits.cargoRoom.data)

  const buildYearOptions = () => {
    const now = moment().locale('fa')
    const currentYear = now.jYear()
    const currentMonth = now.jMonth() + 1
    const currentDay = now.jDate()

    let maxYear = currentYear
    if (currentMonth === 11 && currentDay > 15) {
      maxYear = currentYear + 1
    } else if (currentMonth === 12) {
      maxYear = currentYear + 1
    }

    const minYear = 1335
    const years: any[] = []

    for (let year = maxYear; year >= minYear; year--) {
      years.push({
        value: year,
        label: `${year} - ${year + 621}`,
      })
    }

    return years
  }

  const yearOfConstructions = buildYearOptions()

  useEffect(() => {
    setValue('plate', carInfo.plate)
    setValue('vehicleTypeId', carInfo.vehicleTypeId)
    setValue('vehicleBrandId', carInfo.vehicleBrandId)
    setValue('vehicleTipId', carInfo.vehicleTipId)
    setValue('vehicleColorId', carInfo.vehicleColorId)
    setValue('cargoCompartmentId', carInfo.cargoCompartmentId)
    setValue('vehicleUsageId', carInfo.vehicleUsageId)
    setValue('numberOfCylinders', carInfo.numberOfCylinders)
    setValue(
      'vehicleStatus',
      vehicleStatuses.find(x => x.value == carInfo.vehicleStatus),
    )
    setValue(
      'yearOfConstruction',
      yearOfConstructions.find(x => x.value == carInfo.yearOfConstruction),
    )
    setValue('vehicleMileage', carInfo.vehicleMileage)
    setValue('chassisNumber', carInfo.chassisNumber)
    setValue('engineNumber', carInfo.engineNumber)
    setValue('VIN', carInfo.VIN)
  }, [])

  useEffect(() => {
    var plate: IPlateModel = watch('plate')
    if (plate) {
      var isValid = true
      if (plate.type == 'CAR') {
        if (!plate.cityCode) isValid = false
        else if (plate.cityCode.length < 2 || plate.cityCode.length > 2) isValid = false
        else if (Number(plate.cityCode.substring(0, 1)) == 0) isValid = false

        if (!plate.carSerial) isValid = false
        else if (plate.carSerial.length < 3 || plate.carSerial.length > 3) isValid = false
        else if (plate.carSerial.includes('0')) isValid = false

        if (!plate.char) isValid = false

        if (!plate.carOtherNumber) isValid = false
        else if (plate.carOtherNumber.length < 2 || plate.carOtherNumber.length > 2) isValid = false
        else if (plate.carOtherNumber.includes('0')) isValid = false
      } else {
        if (!plate.motorCycleSerial) isValid = false
        else if (plate.motorCycleSerial.length < 3 || plate.motorCycleSerial.length > 3)
          isValid = false
        else if (plate.motorCycleSerial.includes('0')) isValid = false

        if (!plate.motorCycleOtherNumber) isValid = false
        else if (plate.motorCycleOtherNumber.length < 5 || plate.motorCycleOtherNumber.length > 5)
          isValid = false
        else if (plate.motorCycleOtherNumber.includes('0')) isValid = false
      }
      if (isValid) {
        var isNotLastInquiryResult =
          carInfo.plate?.type != plate.type ||
          carInfo.plate?.cityCode != plate.cityCode ||
          carInfo.plate?.carSerial != plate.carSerial ||
          carInfo.plate?.char != plate.char ||
          carInfo.plate?.carOtherNumber != plate.carOtherNumber ||
          carInfo.plate?.motorCycleSerial != plate.motorCycleSerial ||
          carInfo.plate?.motorCycleOtherNumber != plate.motorCycleOtherNumber
        if (isNotLastInquiryResult) getLicensePlateInquiry(plate)
        else if (plate.type == 'MOTOR_CYCLE') setValue('vehicleTypeId', 28)
      } else if (plate.type == 'MOTOR_CYCLE') setValue('vehicleTypeId', 28)
    }
  }, [watch('plate')])

  const getOcrInquiry = async () => {
    if (netStatus == 'MANUAL_OFF') return

    const ids = QueryStringBuilder({
      imageIds:
        vehicleVisitingPoints?.data?.filter(c => c.isPlatePhotoAvailable).map(x => x.fileId) || [],
    })
    setOcrLoading(true)
    await instance
      .get(`${VisitsApiPaths.GetPlateInformationFromImageIds}?${ids}`, {
        timeout: 60000,
      })
      .then(res => {
        if (res.status === 200) {
          if (res.data && res.data.isPlateRecognized && res.data.plateSerialData) {
            var plate: IPlateModel = {
              type: res.data.plateSerialData.plateType == 1 ? 'CAR' : 'MOTOR_CYCLE',
              cityCode: res.data.plateSerialData.plateCityCode,
              char: res.data.plateSerialData.plateChar,
              carSerial: res.data.plateSerialData.plateCarSerial,
              motorCycleSerial: res.data.plateSerialData.plateMotorCycleSerial,
              carOtherNumber: res.data.plateSerialData.plateCarOtherNumber,
              motorCycleOtherNumber: res.data.plateSerialData.plateMotorCycleOtherNumber,
            }
            setValue('plate', plate)
          }
          if (res.data && res.data?.isPlateInquirySuccessful && res.data.vehicleInquiryData) {
            setValue('vehicleTypeId', res.data.vehicleInquiryData.vehicleTypeId)
            setValue('vehicleUsageId', res.data.vehicleInquiryData.vehicleUsageId)
            setValue('vehicleBrandId', res.data.vehicleInquiryData.vehicleBrandId)
            setValue('vehicleTipId', res.data.vehicleInquiryData.vehicleTipId)
            setValue('numberOfCylinders', null)
            setValue(
              'yearOfConstruction',
              yearOfConstructions.find(
                x => x.value == res.data.vehicleInquiryData.yearOfConstruction,
              ),
            )
            setValue('chassisNumber', res.data.vehicleInquiryData.chassisNumber)
            setValue('engineNumber', res.data.vehicleInquiryData.engineNumber)
          }
        }
        setInterval(() => {
          setOcrLoading(false)
        }, 1)
      })
      .catch(error => {
        setOcrLoading(false)
      })
  }

  const getLicensePlateInquiry = async (plate: IPlateModel) => {
    if (netStatus === 'MANUAL_OFF' || plate.type !== 'CAR') return
    if (draftVisitId) return

    setLicensePlateInquiryLoading(true)
    await instance
      .post(
        VisitsApiPaths.GetLicensePlateInquiry,
        plate.type == 'CAR'
          ? {
            licensePlateNumber: `${plate.carOtherNumber}${plate.char}${plate.carSerial}`,
            plateNumberSeries: plate.cityCode,
          }
          : {
            licensePlateNumberMotorCycle: plate.motorCycleOtherNumber,
            plateNumberSeries: plate.motorCycleSerial,
          },
        { timeout: 60000 },
      )
      .then(res => {
        if (res.status === 200) {
          setValue('vehicleTypeId', res.data.vehicleTypeId)
          setValue('vehicleUsageId', res.data.vehicleUsageId)
          setValue('vehicleBrandId', res.data.vehicleBrandId)
          setValue('vehicleTipId', res.data.vehicleTipId)
          setValue('numberOfCylinders', null)
          setValue(
            'yearOfConstruction',
            yearOfConstructions.find(x => x.value == res.data.yearOfConstruction),
          )
          setValue('chassisNumber', res.data.chassisNumber)
          setValue('engineNumber', res.data.engineNumber)
        }
        setInterval(() => {
          setLicensePlateInquiryLoading(false)
        }, 1)
      })
      .catch(error => {
        setLicensePlateInquiryLoading(false)
      })
  }

  useEffect(() => {
    if (
      !(watch('vehicleTypeId') == carInfo.vehicleTypeId) &&
      !licensePlateInquiryLoading &&
      !ocrLoading
    ) {
      setValue('vehicleUsageId', null)
      setValue('vehicleBrandId', null)
      setValue('vehicleTipId', null)
    }
  }, [watch('vehicleTypeId')])

  useEffect(() => {
    if (
      !(watch('vehicleBrandId') == carInfo.vehicleBrandId) &&
      !licensePlateInquiryLoading &&
      !ocrLoading
    )
      setValue('vehicleTipId', null)
  }, [watch('vehicleBrandId')])

  var vehicleStatuses = [
    { value: 1, label: t('SALEM') },
    { value: 2, label: t('HURT') },
    { value: 3, label: t('UNINSURABLE') },
  ]
  var numberOfCylinders = [
    { value: 1, label: 1 },
    { value: 2, label: 2 },
    { value: 3, label: 3 },
    { value: 4, label: 4 },
    { value: 5, label: 5 },
    { value: 6, label: 6 },
    { value: 7, label: 7 },
    { value: 8, label: 8 },
    { value: 9, label: t('HYBRID') },
    { value: 10, label: t('ELECTRIC') },
  ]

  const submitForm = async (data: any) => {
    dispatch(
      setCarInfo({
        plate: data.plate,
        vehicleTypeId: data.vehicleTypeId?.value ? data.vehicleTypeId?.value : data.vehicleTypeId,
        hasTrailer: vehicleTypesData.find(
          x =>
            x.value == (data.vehicleTypeId?.value ? data.vehicleTypeId?.value : data.vehicleTypeId),
        )?.hasTrailer,
        vehicleBrandId: data.vehicleBrandId?.value
          ? data.vehicleBrandId?.value
          : data.vehicleBrandId,
        vehicleTipId: data.vehicleTipId?.value ? data.vehicleTipId?.value : data.vehicleTipId,
        cargoCompartmentId: vehicleTypesData.find(
          x => x.value === (data.vehicleTypeId?.value ?? data.vehicleTypeId),
        )?.hasCargoRoom
          ? data.cargoCompartmentId?.value
            ? data.cargoCompartmentId?.value
            : data.cargoCompartmentId
          : null,
        vehicleColorId: data.vehicleColorId?.value
          ? data.vehicleColorId?.value
          : data.vehicleColorId,
        vehicleUsageId: data.vehicleUsageId?.value
          ? data.vehicleUsageId?.value
          : data.vehicleUsageId,
        vehicleStatus:
          data.vehicleStatus?.value || data.vehicleStatus?.value == 0
            ? data.vehicleStatus?.value
            : data.vehicleStatus,
        numberOfCylinders: data.numberOfCylinders?.value
          ? data.numberOfCylinders?.value
          : data.numberOfCylinders,
        yearOfConstruction: data.yearOfConstruction?.value
          ? data.yearOfConstruction?.value
          : data.yearOfConstruction,
        vehicleMileage: data.vehicleMileage,
        chassisNumber: data.chassisNumber,
        engineNumber: data.engineNumber,
        VIN: data.VIN,
      }),
    )
    props.handleNext()
  }

  return (
    <React.Fragment>
      <div
        className={`flex flex-col grow overflow-auto${licensePlateInquiryLoading || ocrLoading ? ' loading' : ''}`}
      >
        <div className="px-6 pb-6">
          <div className="text-sm mb-8">مشخصات {t('VEHICLE')} را وارد کنید.</div>

          <form>
            <div className="space-y-4">
              <PlateInput
                name="plate"
                control={control}
                errors={errors}
                rules={{ required: true }}
                disabled={!!draftVisitId && !!carInfo.plate}
                typeDisabled={!!draftVisitId && !!carInfo.plate?.type}
                mode={false}
              />

              <FDMBottomSheetSelectInput
                id="vehicleTypeId"
                name="vehicleTypeId"
                control={control}
                label={t('VEHICLE_TYPE')}
                rules={{
                  required: true,
                }}
                withSearch
                errors={errors.vehicleTypeId}
                options={vehicleTypesData}
                disabled={!!draftVisitId && !!carInfo.vehicleTypeId}
              />

              <FDMBottomSheetSelectInput
                id="vehicleUsageId"
                name="vehicleUsageId"
                control={control}
                label={t('VEHICLE_USAGE')}
                rules={{
                  required: true,
                }}
                withSearch
                errors={errors.vehicleUsageId}
                disabled={!!draftVisitId && !!carInfo.vehicleUsageId}
                options={vehicleUsagesData.filter(
                  (x: any) =>
                    x.vehicleTypeId ==
                    (watch('vehicleTypeId')?.value
                      ? watch('vehicleTypeId')?.value
                      : watch('vehicleTypeId')),
                )}
              />

              <FDMBottomSheetSelectInput
                id="vehicleBrandId"
                name="vehicleBrandId"
                control={control}
                label={t('VEHICLE_BRAND')}
                rules={{
                  required: true,
                }}
                withSearch
                errors={errors.vehicleBrandId}
                disabled={!!draftVisitId && !!carInfo.vehicleBrandId}
                options={vehicleBrandsData.filter(
                  (x: any) =>
                    x.vehicleTypeId ==
                    (watch('vehicleTypeId')?.value
                      ? watch('vehicleTypeId')?.value
                      : watch('vehicleTypeId')),
                )}
              />

              <FDMBottomSheetSelectInput
                id="vehicleTipId"
                name="vehicleTipId"
                control={control}
                label={t('VEHICLE_TIP')}
                rules={{
                  required: true,
                }}
                withSearch
                errors={errors.vehicleTipId}
                disabled={!!draftVisitId && !!carInfo.vehicleTipId}
                options={vehicleTipsData.filter(
                  (x: any) =>
                    x.vehicleTypeId ==
                    (watch('vehicleTypeId')?.value
                      ? watch('vehicleTypeId')?.value
                      : watch('vehicleTypeId')) &&
                    x.vehicleBrandId ==
                    (watch('vehicleBrandId')?.value
                      ? watch('vehicleBrandId')?.value
                      : watch('vehicleBrandId')),
                )}
              />

              {vehicleTypesData.find(
                x => x.value === (watch('vehicleTypeId')?.value ?? watch('vehicleTypeId')),
              )?.hasCargoRoom && (
                  <FDMBottomSheetSelectInput
                    id="cargoCompartmentId"
                    name="cargoCompartmentId"
                    control={control}
                    label={t('CARGO_COMPARTMENT')}
                    rules={{
                      required: true,
                    }}
                    withSearch
                    errors={errors.cargoCompartmentId}
                    options={cargoRoomData.filter(
                      (x: any) =>
                        x.vehicleTypeId ==
                        (watch('vehicleTypeId')?.value
                          ? watch('vehicleTypeId')?.value
                          : watch('vehicleTypeId')),
                    )}
                  />
                )}

              <FDMBottomSheetSelectInput
                id="vehicleColorId"
                name="vehicleColorId"
                control={control}
                label={t('VEHICLE_COLOR')}
                rules={{
                  required: true,
                }}
                withSearch
                errors={errors.vehicleColorId}
                options={vehicleColorsData}
                disabled={!!draftVisitId && !!carInfo.vehicleColorId}
              />

              <FDMBottomSheetSelectInput
                id="yearOfConstruction"
                name="yearOfConstruction"
                control={control}
                label={t('YEAR_OF_CONSTRUCTION')}
                disabled={!!draftVisitId && !!carInfo.vehicleTipId}
                rules={{
                  required: true,
                }}
                withSearch
                errors={errors.yearOfConstruction}
                options={yearOfConstructions}
              />

              <FDMBottomSheetSelectInput
                id="vehicleStatus"
                name="vehicleStatus"
                control={control}
                label={t('VEHICLE_STATUS')}
                rules={{
                  required: true,
                }}
                errors={errors.vehicleStatus}
                options={vehicleStatuses}
              />

              <FDMBottomSheetSelectInput
                id="numberOfCylinders"
                name="numberOfCylinders"
                control={control}
                label={t('NUMBER_OF_CYLINDERSE')}
                rules={{
                  required: true,
                }}
                errors={errors.numberOfCylinders}
                options={numberOfCylinders}
              />

              <CurrencyInput
                inputmode="numeric"
                id="vehicleMileage"
                name="vehicleMileage"
                label={t('VEHICLE_MILEAGE')}
                unitText={t('KILOMETER')}
                control={control}
                errors={errors.vehicleMileage}
                dir="rtl"
                rules={{
                  required: true,
                  min: 0,
                  max: 100000000000,
                }}
              />

              <TextInput
                id="chassisNumber"
                name="chassisNumber"
                label={t('CHASSIS_NUMBER')}
                uppercase={true}
                onKeyPress={englishFilterOnKeyPress}
                control={control}
                errors={errors.chassisNumber}
                disabled={!!draftVisitId && !!carInfo.chassisNumber}
                rules={{
                  required: true,
                  minLength: 6,
                  maxLength: 20,
                }}
              />

              <TextInput
                id="engineNumber"
                name="engineNumber"
                label={t('ENGINE_NUMBER')}
                uppercase={true}
                onKeyPress={englishFilterOnKeyPress}
                control={control}
                errors={errors.engineNumber}
                disabled={!!draftVisitId && !!carInfo.engineNumber}
                rules={{
                  required: true,
                  minLength: 6,
                  maxLength: 20,
                }}
              />
              <TextInput
                id="VIN"
                name="VIN"
                label={t('VIN')}
                uppercase={true}
                onKeyPress={englishFilterOnKeyPress}
                control={control}
                errors={errors.VIN}
                disabled={!!draftVisitId && !!carInfo.VIN}
                rules={{
                  required: true,
                  minLength: 17,
                  maxLength: 17,
                }}
              />

              {customerDeliberately.vehicleDeliberatelyType == 'CARD'
                ? (customerDeliberately.vehicleCard || customerDeliberately.vehicleCardBack) && (
                  <div className="flex gap-4 mt-3">
                    {customerDeliberately.vehicleCard && (
                      <PodSpaceImage
                        isPodSpace={storeFileType == 'POD_SPACE'}
                        className="flex items-end w-40 h-36 rounded-lg border border-gray-500 bg-cover bg-no-repeat bg-center overflow-hidden"
                        hashFile={customerDeliberately.vehicleCard?.hashFile}
                        fileId={customerDeliberately.vehicleCard?.fileId}
                        fileContent={customerDeliberately.vehicleCard?.image}
                        onLoad={(image: string) =>
                          dispatch(
                            setDeliberatelyFileContent({
                              id: customerDeliberately.vehicleCard?.id,
                              image,
                            }),
                          )
                        }
                      >
                        <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                          {t('VEHICLE_CARD_FRONT')}
                        </div>
                      </PodSpaceImage>
                    )}
                    {customerDeliberately.vehicleCardBack && (
                      <PodSpaceImage
                        isPodSpace={storeFileType == 'POD_SPACE'}
                        className="flex items-end w-40 h-36 rounded-lg border border-gray-500 bg-cover bg-no-repeat bg-center overflow-hidden"
                        hashFile={customerDeliberately.vehicleCardBack?.hashFile}
                        fileId={customerDeliberately.vehicleCardBack?.fileId}
                        fileContent={customerDeliberately.vehicleCardBack?.image}
                        onLoad={(image: string) =>
                          dispatch(
                            setDeliberatelyFileContent({
                              id: customerDeliberately.vehicleCardBack?.id,
                              image,
                            }),
                          )
                        }
                      >
                        <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                          {t('VEHICLE_CARD_BACK')}
                        </div>
                      </PodSpaceImage>
                    )}
                  </div>
                )
                : customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? customerDeliberately.vehicleDoc && (
                    <PodSpaceImage
                      isPodSpace={storeFileType == 'POD_SPACE'}
                      className="flex items-end w-40 h-36 rounded-lg border border-gray-500 bg-cover bg-no-repeat bg-center overflow-hidden mt-3"
                      hashFile={customerDeliberately.vehicleDoc?.hashFile}
                      fileId={customerDeliberately.vehicleDoc?.fileId}
                      fileContent={customerDeliberately.vehicleDoc?.image}
                      onLoad={(image: string) =>
                        dispatch(
                          setDeliberatelyFileContent({
                            id: customerDeliberately.vehicleDoc?.id,
                            image,
                          }),
                        )
                      }
                    >
                      <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                        {t('VEHICLE_DOC')}
                      </div>
                    </PodSpaceImage>
                  )
                  : customerDeliberately.vehicleCompanyDoc && (
                    <PodSpaceImage
                      isPodSpace={storeFileType == 'POD_SPACE'}
                      className="flex items-end w-40 h-36 rounded-lg border border-gray-500 bg-cover bg-no-repeat bg-center overflow-hidden mt-3"
                      hashFile={customerDeliberately.vehicleCompanyDoc?.hashFile}
                      fileId={customerDeliberately.vehicleCompanyDoc?.fileId}
                      fileContent={customerDeliberately.vehicleCompanyDoc?.image}
                      onLoad={(image: string) =>
                        dispatch(
                          setDeliberatelyFileContent({
                            id: customerDeliberately.vehicleCompanyDoc?.id,
                            image,
                          }),
                        )
                      }
                    >
                      <div className="bg-white p-2 text-center text-gray-900 text-xs w-full">
                        {t('VEHICLE_COMPANY_DOC')}
                      </div>
                    </PodSpaceImage>
                  )}
            </div>
          </form>
        </div>
      </div>
      <div className="cta">
        <div className="flex justify-between items-center gap-2">
          <button
            className="btn btn-warning btn-lg flex gap-2 items-center justify-center w-full"
            onClick={props.handleBack}
          >
            <Icon name="arrow-right" className="w-6 h-6" />
            {t('BACK')}
          </button>
          <button
            className="btn btn-primary btn-lg flex gap-2 items-center justify-center w-full"
            onClick={handleSubmit(submitForm)}
          >
            {t('NEXT')}
            <Icon name="arrow-left" className="w-6 h-6" />
          </button>
        </div>
      </div>
    </React.Fragment>
  )
}

export default GetCarInfoPage
